import { Button, Loading, Modal, Panel } from "@alm/flow-ds/components";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
	onDeleteRole: () => void;
	loading: boolean;
	systemRole: boolean;
}

export default ({ onDeleteRole, loading, systemRole }: Props) => {
	const { t } = useTranslation();

	const [isPanelOpen, setIsPanelOpen] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<>
			<Panel
				className="admin__role-form__danger"
				isOpen={isPanelOpen}
				open={() => setIsPanelOpen(!isPanelOpen)}
				title={t("main.admin.headings.dangerZone")}
				id="admin-danger-panel">
				<div className="admin__role-form__danger-title">
					{t("main.admin.labels.deleteRole")}
				</div>
				<div className="admin__role-form__danger-msg">
					{t("main.admin.text.deleteRoleMsg")}
				</div>
				<Button
					label={t("main.admin.labels.deleteRole")}
					className="btn-danger admin__role-form__danger-btn"
					onClick={() => setIsModalOpen(true)}
					disabled={systemRole}
				/>
			</Panel>
			<Modal
				isOpen={isModalOpen}
				modalSize="sm"
				showHeaderClose={false}
				close={() => setIsModalOpen(false)}
				title={t("main.admin.headings.areYouSure")}
				closeAriaLabel={t("main.icons.closeModal")}
				className="admin__role-form__danger-modal"
				footer={
					<div className="d-flex justify-content-between w-100">
						<Button
							className="me-auto m-0 p-1"
							label={t("common.labels.cancel")}
							onClick={() => setIsModalOpen(false)}
						/>

						<Button
							className="btn-danger pe-4 ps-4"
							label={!loading && t("common.labels.delete")}
							onClick={onDeleteRole}>
							{loading && <Loading />}
						</Button>
					</div>
				}>
				<p aria-live="assertive">
					{t("main.admin.text.deleteRoleModalMsg")}
				</p>
			</Modal>
		</>
	);
};
